import { ChevronDown, Mouse, Trackpad } from 'ui/icons';

const isMac = navigator.userAgent.indexOf('Mac OS') > -1;

export const MOUSE = 'Mouse';
export const TRACKPAD = 'Trackpad';

export type ActionType = {
  action: string;
  shortcuts: any[];
};

const NAVIGATION_TIPS: Record<string, ActionType> = {
  AddNew: {
    action: 'Add a new tile or note',
    shortcuts: [
      <>
        <kbd>Single-click</kbd> + <kbd>Drag</kbd> <span>from panel to canvas</span>
      </>,
    ],
  },
  SelectTile: {
    action: 'Select a tile',
    shortcuts: [
      <>
        <kbd>Single-click</kbd>
      </>,
    ],
  },
  OpenTile: {
    action: 'Open a tile',
    shortcuts: [
      <>
        <kbd>Double-click</kbd>
      </>,
    ],
  },
  SelectMultiple: {
    action: 'Select multiple tiles',
    shortcuts: [
      <>
        <kbd>Shift</kbd> + <kbd>Single-click</kbd>
      </>,
      <>
        <span>or</span> <kbd>Shift</kbd> + <kbd>Single-click</kbd> + <kbd>Drag</kbd>{' '}
        <span>around multiple tiles</span>
      </>,
    ],
  },
  Copy: {
    action: 'Copy selected tiles',
    shortcuts: [
      <>
        <kbd>{isMac ? '⌘ Cmd' : 'Ctrl'}</kbd> + <kbd>c</kbd>
      </>,
    ],
  },
  Paste: {
    action: 'Paste copied tiles',
    shortcuts: [
      <>
        <kbd>{isMac ? '⌘ Cmd' : 'Ctrl'}</kbd> + <kbd>v</kbd>
      </>,
    ],
  },
  Delete: {
    action: 'Delete selected tiles',
    shortcuts: [
      <>
        <kbd>Delete</kbd> or <kbd>Backspace</kbd>
      </>,
    ],
  },
};

const BASE_NAVIGATION_TIPS = [
  NAVIGATION_TIPS.AddNew,
  NAVIGATION_TIPS.SelectTile,
  NAVIGATION_TIPS.OpenTile,
  NAVIGATION_TIPS.SelectMultiple,
  NAVIGATION_TIPS.Copy,
  NAVIGATION_TIPS.Paste,
  NAVIGATION_TIPS.Delete,
];

const MOUSE_NAVIGATION_TIPS = [
  {
    action: 'Pan view',
    shortcuts: [
      <>
        <kbd>Scroll</kbd> <span>to pan vertically</span>
      </>,
      <>
        <kbd>Shift</kbd> + <kbd>Scroll</kbd> <span>to pan horizontally</span>
      </>,
    ],
  },
  {
    action: 'Zoom in/out',
    shortcuts: [
      <>
        <kbd>
          <ChevronDown height={12} width={24} style={{ transform: 'rotate(180deg)' }} /> Ctrl
        </kbd>{' '}
        + <kbd>Scroll</kbd>
      </>,
    ],
  },
  ...BASE_NAVIGATION_TIPS,
];

const TRACKPAD_NAVIGATION_TIPS = [
  {
    action: 'Pan view',
    shortcuts: [
      <>
        <kbd>Two-finger swipe</kbd>
      </>,
    ],
  },
  {
    action: 'Zoom in/out',
    shortcuts: [
      <>
        <kbd>Two-finger pinch</kbd>
      </>,
    ],
  },
  ...BASE_NAVIGATION_TIPS,
];

export const CONTROL_BAR_OPTIONS = [
  { name: MOUSE, icon: Mouse, tips: MOUSE_NAVIGATION_TIPS },
  {
    name: TRACKPAD,
    icon: Trackpad,
    tips: TRACKPAD_NAVIGATION_TIPS,
  },
];
